// CircleNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const CircleNode = ({ data }) => {
  return (
    <div
      style={{
        background: data.color || "#007bff",
        color: "#fff",
        borderRadius: "50%",
        width: 50,
        height: 50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "8px",
        textAlign: "center",
        lineHeight: "1.2em",
      }}
    >
      {data.label}

      {/* Handles for edges */}
      <Handle type="source" position={Position.Top} id="top" />
      <Handle type="source" position={Position.Right} id="right" />
      <Handle type="source" position={Position.Bottom} id="bottom" />
      <Handle type="source" position={Position.Left} id="left" />

      <Handle type="target" position={Position.Top} id="t-top" />
      <Handle type="target" position={Position.Right} id="t-right" />
      <Handle type="target" position={Position.Bottom} id="t-bottom" />
      <Handle type="target" position={Position.Left} id="t-left" />

      {/* Custom corner handles */}
      <Handle
        type="source"
        id="s-top-left"
        position={Position.Top}
        style={{ left: 7, top: 3 }} // move slightly inside
      />
      <Handle
        type="source"
        id="s-top-right"
        position={Position.Top}
        style={{
          top: 3, // adjust vertical alignment
          right: 6, // stick to the right
          left: "auto", // reset left
          transform: "none", // remove React Flow's default centering
        }}
      />
      <Handle
        type="source"
        id="s-bottom-left"
        position={Position.Bottom}
        style={{ left: 7, bottom: 3 }}
      />
      <Handle
        type="source"
        id="s-bottom-right"
        position={Position.Bottom}
        style={{
          bottom: 4, // adjust vertical alignment
          right: 5, // stick to the right
          left: "auto", // reset left
          transform: "none", // remove React Flow's default centering
        }}
      />

      <Handle
        type="target"
        id="t-top-left"
        position={Position.Top}
        style={{ left: 7, top: 3 }}
      />
      <Handle
        type="target"
        id="t-top-right"
        position={Position.Top}
        style={{
          top: 3, // adjust vertical alignment
          right: 6, // stick to the right
          left: "auto", // reset left
          transform: "none", // remove React Flow's default centering
        }}
      />
      <Handle
        type="target"
        id="t-bottom-left"
        position={Position.Bottom}
        style={{ left: 7, bottom: 3 }}
      />
      <Handle
        type="target"
        id="t-bottom-right"
        position={Position.Bottom}
        style={{
          bottom: 4, // adjust vertical alignment
          right: 5, // stick to the right
          left: "auto", // reset left
          transform: "none", // remove React Flow's default centering
        }}
      />
    </div>
  );
};

export default CircleNode;
